import React from 'react';

const ML_Intro = () => {
    return (
        <div>ML_Intro Component</div>
    );
}

export default ML_Intro;
